<template>
  <div>
    <nr-generic
      title="Reembolso dos Funcionários"
      namespace="refund_notes_employees_open"
      searchObject='employee'
      :searchFields="['cost_center_employee']"
      :showFilter="true"
      :showPagination="true"
      >
      <template v-slot:header>
        <th v-for="item in headers" :key="item.label">{{ item.label }}</th>
      </template>
      <template v-slot:item="{ item }">
        <td>
          {{ item.full_name }} <!-- {{ item.full_name }} -->
        </td>
        <td>{{ item.num_open_refunds }}</td>
        <td>
          <b-button variant="success" @click="openModal(item)">
            <i class="fa fa-plus"></i> Gerar nota de pagamento
          </b-button>
        </td>
      </template>
    </nr-generic>

    <b-modal :visible="isVisible" title="Gerar Nota de Reembolso" @ok="generateNote" @hidden="clearModal" id="refund-note-modal">
      <h5 class="mb-3">{{ selectedItem.cost_center__social_name }}</h5>

      <b-form-group label="Data de Vencimento">
        <datepicker
          v-model="expirationDate"
          format="dd/MM/yy"
          input-class="form-control"
          :use-utc="true"
        />
      </b-form-group>

      <div class="font-weight-bold text-right">Total: R$ {{ selectedTotal | formatPrice }}</div>

      <b-table class="mt-3" striped selectable :items="refundNotes" :fields="tableFields" @row-selected="onRowSelected" ref="the_table">
        <template v-slot:head(checkbox)="data">
          <b-form-checkbox @change="selectAll($event)" v-model="allSelected"></b-form-checkbox>
        </template>

        <template v-slot:cell(checkbox)="data">
          <b-form-checkbox :checked="data.rowSelected" @change="selectRow($event, data.index)"></b-form-checkbox>
        </template>

        <template v-slot:cell(payment_date)="data">
          {{ data.item.payment_date | formatDate }}
        </template>

        <template v-slot:cell(value)="data">
          <div class="d-flex justify-content-between" style="width: 85px;">
            <span>R$</span>
            <span>{{ data.item.value | formatPrice }}</span>
          </div>
        </template>
      </b-table>

      <div class="font-weight-bold text-right">Total: R$ {{ selectedTotal | formatPrice }}</div>
    </b-modal>
  </div>
</template>
<script>
import NRGeneric from './NRGeneric';
import axios from 'axios';

import moment from 'moment';
import 'moment/locale/pt-br';

import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    'nr-generic': NRGeneric,
    Datepicker,
  },
  data() {
    return {
      isVisible: false,
      selectedItem: {},
      refundNotes: [],
      headers: [
        { label: 'Funcionário' },
        { label: 'Reembolsos sem Nota' },
        { label: 'Ações' },
      ],
      selected: [],
      allSelected: false,
      expirationDate: null,
      tableFields: [
        {
          key: 'checkbox',
        },
        {
          key: 'payment_date',
          label: 'Data'
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'value',
          label: 'Valor'
        },
      ],
    }
  },
  computed: {
    selectedTotal() {
      return this.selected.reduce((prev, curr) => {
        return prev + Number(curr.value);
      }, 0)
    },
  },
  methods: {
    generateNote() {
      axios.post('/financial/action/generate-refund-notes-employee/', {
        employee_pk: this.selectedItem.employee_pk,
        selected_items_pks: this.selected.map(s => s.pk),
        expirationDate: this.expirationDate,
      })
        .then(() => {
          this.$store.dispatch('refund_notes_employees_open/loadItems');
          this.$store.dispatch('refund_notes_employees/loadItems');
        });
    },
    openModal(item) {
      this.isVisible = true;
      this.selectedItem = item;
      this.expirationDate = new Date().toISOString().split('T')[0];

      axios.get('/financial/refund-note/employees/' + item.employee_pk + '/without-nr/')
        .then(res => {
          this.refundNotes = res.data.data;

          setTimeout(() => {
            this.selectAll(true);
          }, 100);
        });
    },
    clearModal() {
      this.isVisible = false;
    },
    onRowSelected(items) {
      this.selected = items;

      if (this.selected.length == this.refundNotes.length) {
        this.allSelected = true;
        return;
      }

      this.allSelected = false;
    },
    selectAll(event) {
      this.allSelected = event;

      const items = this.refundNotes;
      const theItems = [...items].map((item, i) => {
        return {
          ...item,
          index: i,
        }
      });

      const selectedPks = this.selected.map(s => s.pk);

      const indexes = theItems.filter(i => {
        if (event) {
          return !selectedPks.includes(i.pk);
        }

        return selectedPks.includes(i.pk);
      })
        .map(i => i.index);

      this.clickRows(indexes);
    },
    selectRow(event, i) {
      this.clickRows([i]);

      if (this.selected.length == this.refundNotes.length) {
        this.allSelected = true;
        return;
      }

      this.allSelected = false;
    },
    clickRows(which) {
      let myTable = this.$refs.the_table.$el,
          tableBody = myTable.getElementsByTagName('tbody')[0],
          tableRows = tableBody.getElementsByTagName('tr')
      which.forEach(idx => {
        tableRows[idx].click()
      })
    },
  }
}
</script>

<style>
#refund-note-modal .modal-dialog {
  max-width: 70% !important;
}
</style>


<!--<template>-->
<!--  <div>-->
<!--    <nr-generic-->
<!--      title="Notas de Reembolso dos Funcionários"-->
<!--      namespace="refund_notes_employees"-->
<!--      searchObject='employee'-->
<!--      :searchFields="['full_name']"-->
<!--      :showFilter="true"-->
<!--      :showPagination="true"-->
<!--      >-->
<!--      <template v-slot:header>-->
<!--        <th v-for="item in headers">{{ item.label }}</th>-->
<!--      </template>-->
<!--      <template v-slot:item="{ item }">-->
<!--        <td>-->
<!--          <router-link :to="'/financials/repayment/employee/' + item.pk">{{ item.code }}</router-link><br>-->
<!--          &lt;!&ndash; <small v-if="$store.getters['auth/isAdmin']" class="text-muted" title="Criado por">{{ item.created_by }}</small> &ndash;&gt;-->
<!--        </td>-->
<!--        <td>{{ item.employee.full_name }}</td>-->
<!--        <td>{{ item.expiration_date | formatDate }}</td>-->
<!--        <td>R$ {{ item.total | formatPrice }}</td>-->
<!--        <td><input type="checkbox" class="checkbox-circular" :checked="isChecked(item)" @click="updateItemStatus(item)"></td>-->
<!--      </template>-->
<!--    </nr-generic>-->
<!--  </div>-->
<!--</template>-->
<!--<script>-->
<!--import NRGeneric from './NRGeneric';-->
<!--import axios from 'axios';-->

<!--export default {-->
<!--  components: {-->
<!--    'nr-generic': NRGeneric,-->
<!--  },-->
<!--  computed: {-->
<!--    isChecked() {-->
<!--      return item => item.paid;-->
<!--    },-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      headers: [-->
<!--        { label: 'Nota' },-->
<!--        { label: 'Funcionário' },-->
<!--        { label: 'Vencimento' },-->
<!--        { label: 'Valor' },-->
<!--        { label: 'Status (Pago)' },-->
<!--      ]-->
<!--    }-->
<!--  },-->
<!--  methods: {-->
<!--    updateItemStatus: function (item) {-->
<!--      const payload = {'pk': item.pk, 'paid': item.paid = !item.paid}-->
<!--      let bodyFormData = new FormData();-->
<!--      bodyFormData.append('obj', JSON.stringify(payload));-->
<!--      axios.post('/financial/refund-note/employees/' + item.pk + '/update_paid_status/', bodyFormData)-->
<!--    },-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style>-->
<!--.checkbox-circular {-->
<!--  /* Tamanho do checkbox */-->
<!--  width: 20px;-->
<!--  height: 20px;-->

<!--  /* Borda circular */-->
<!--  border-radius: 50%;-->

<!--  /* Apaga o checkbox padrão */-->
<!--  appearance: none;-->
<!--  -webkit-appearance: none;-->

<!--  /* Posicionamento do cursor */-->
<!--  cursor: pointer;-->

<!--  /* Borda */-->
<!--  border: 2px solid #ccc;-->

<!--  /* Transição suave */-->
<!--  transition: 0.2s;-->
<!--  position: relative;-->
<!--}-->

<!--/* Checkbox selecionado */-->
<!--.checkbox-circular:checked {-->
<!--  background-color: #42ce0f;-->
<!--  border-color: #42ce0f;-->
<!--}-->

<!--/* Checkbox não selecionado */-->
<!--.checkbox-circular:not(:checked) {-->
<!--  background-color: #ff4b4b;;-->
<!--  border-color: #ff4b4b;-->
<!--}-->

<!--/* Insere x no checkbox não selecionado */-->
<!--.checkbox-circular::before {-->
<!--  content: "x";-->
<!--  position: absolute;-->
<!--  top: 50%;-->
<!--  left: 50%;-->
<!--  transform: translate(-45%, -50.5%);-->
<!--  font-size: 14px;-->
<!--  color: #fff;-->
<!--}-->

<!--/* Insere verificado no checkbox selecionado */-->
<!--.checkbox-circular:checked::before {-->
<!--  content: "✓";-->
<!--  font-size: 18px;-->
<!--  color: #fff;-->
<!--  transform: translate(-45%, -47%);-->
<!--}-->
<!--</style>-->
